import { url } from '@/utils';

const cookie = {
  set: (key, value, expires, path, domain) => {
    // expires Number（cookie过期时间 默认'会话结束过期' 单位'天'）
    // path String（cookie路径 默认'/'）
    // domain String（cookie域 默认当前一级域名）
    let cookie = `${ key }=${ typeof value === 'object' ? JSON.stringify(value) : value }`;
    // 设置有效期
    if (expires) {
      const date = new Date();
      date.setTime(date.getTime() + expires * 24 * 3600 * 1000);
      cookie += `;expires=${ date.toGMTString() }`;
    }
    // 设置cookie路径
    cookie += `;path=${ path || '/' }`;
    // 设置cookie域
    const defaultDomain = process.env.NODE_ENV === 'production' ?  url.getTopDomain() : 'localhost';
    cookie += `;domain=${ domain || defaultDomain }`;
    // 设置cookie
    document.cookie = cookie;
  },
  get: key => {
    const arrCookie = document.cookie.split('; ');
    for (let i in arrCookie) {
      if (arrCookie[i].split('=')[0] === key) {
        const data = arrCookie[i].split('=')[1];
        const isJson = (data.includes('[') && data.includes(']')) || (data.includes('{') && data.includes('}'));
        return isJson ? JSON.parse(data) : data;
      }
    }
    return '';
  },
  remove: (key, path, domain) => cookie.set(key, '', -1, path, domain)
}

export default cookie;